export enum OrganizationValidity {
  VALID = 'certificate_active',
  NOT_VALID = 'certificate_expired'
}

export const OrganizationValidityTranslate: Record<string, string> = {
  [OrganizationValidity.VALID]: 'Действует',
  [OrganizationValidity.NOT_VALID]: 'Не действует',
};

export const cert_valid = Object.keys(
  OrganizationValidityTranslate,
).map(
  (f: string) => ({ text: OrganizationValidityTranslate[f], value: f }),
);

export enum AccessReports {
  AVAILABLE = 'true',
  NOT_AVAILABLE = 'false'
}

export const AccessReportsTranslate: Record<string, string> = {
  [AccessReports.AVAILABLE]: 'Доступен',
  [AccessReports.NOT_AVAILABLE]: 'Не доступен',
};

export const access_reports = Object.keys(
  AccessReportsTranslate,
).map(
  (f: string) => ({ text: OrganizationValidityTranslate[f], value: f }),
);
